import { useDispatch } from "react-redux";
import { bookingActions } from "../../../../store/reducers/booking";

import { Grid, Button, DialogContent, DialogActions, Typography } from "@mui/material";

import constants from "../../../../utils/constants";
import LitcoLogo from "../../../../images/LitcoLogo";
import TooltipQuestion from "./TooltipQuestion";

const questions = [
  {
    questionText: "Did the accident happen in Alberta?",
    dialogText:
      "If your accident happened outside of Alberta, we will need to ask you a few additional questions before we can book your appointment. Call # today to speak to a team member.",
  },
  {
    questionText: "Did the accident happen within 2 years?",
    dialogText:
      "If it has been more than 2 years since the date of your accident, you will need to speak with a member of our team before booking a consultation. Call # today to speak to a team member.",
  },
  {
    questionText: "Were you injured in the accident?",
    dialogText:
      "If you did not sustain any injuries from the accident, we will need to speak with you and get more information prior to booking a consultation. Call # today to speak with a member of our team.",
  },
  {
    questionText: "Was another person at fault or partially at fault in the accident?",
    dialogText:
      "If you were at fault for the accident, we recommend contacting your insurance company. If you were only partially at fault or aren’t sure, give us a call at # today to speak with a member of our team.",
  },
  {
    questionText: "Are you currently without a lawyer? ",
    dialogText:
      "If you already have a lawyer, we’ll need to speak with you to get more details before booking your consultation. Call # today to speak with a member of our team.",
  },
  {
    questionText: "Are you over the age of 18?",
    dialogText:
      "If you are under the age of 18, we will need to speak with you to get more information before we can book your consultation. Call # today to speak with a member of our team.",
  },
];

const generateQuestionComponents = () => {
  const questionComponents = [];

  questions.forEach((question, index) =>
    questionComponents.push(
      <Grid item key={index}>
        <TooltipQuestion questionText={question.questionText} dialogText={question.dialogText} index={index} />
      </Grid>
    )
  );

  return questionComponents;
};

export default function PreQualify(props) {
  const dispatch = useDispatch();

  const handleAnswer = (event) => {
    if (event.target.value === "yes") {
      dispatch(bookingActions.updateStatus(constants.BOOKING_STATUS.QUALIFIED));
    } else {
      dispatch(bookingActions.updateStatus(constants.BOOKING_STATUS.NOT_QUALIFIED));
    }
  };

  return (
    <>
      <DialogContent>
        <Grid container direction="column" alignItems="center" spacing={1}>
          <Grid item>
            <LitcoLogo size={35} opacity={0.7} />
          </Grid>
          <Grid item>
            <Typography variant="subtitle1" gutterBottom component="div" sx={{ fontWeight: "bold" }}>
              We just need to ask you a few questions:
            </Typography>
          </Grid>

          <Grid item>
            <Grid container direction="column" spacing={1}>
              {generateQuestionComponents()}
            </Grid>
          </Grid>

          <Grid item mt={2}>
            <Typography variant="body1" gutterBottom sx={{ fontWeight: "bold" }}>
              Did you answer yes to all these questions?
            </Typography>
            <Grid container justifyContent="space-around" mt={1}>
              <Button value={"no"} onClick={handleAnswer} variant="contained" size="small">
                No
              </Button>
              <Button value={"yes"} onClick={handleAnswer} variant="contained" size="small">
                Yes
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Grid container direction="row" justifyContent="space-around" alignItems="center">
          <Grid item>
            <Button onClick={props.onClose} size="small">
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Typography variant="body2">
              <a href={"tel:+" + constants.LITCO_NUMBER}>{constants.LITCO_NUMBER}</a>
            </Typography>
          </Grid>
        </Grid>
      </DialogActions>
    </>
  );
}
